//  Asset Vishal //
export const GET_ASSET = "GET_ASSET";
export const GET_SPECIFICATION_FOR_ASSET_GROUP =
  "GET_SPECIFICATION_FOR_ASSET_GROUP";
export const GET_SPECIFICATION_FOR_ASSET_GROUP1 =
  "GET_SPECIFICATION_FOR_ASSET_GROUP1";
export const GET_ASSET_FILTER_GROUP = "GET_ASSET_FILTER_GROUP";
export const GET_COMPANY_FOR_ASSET_GROUP = "GET_COMPANY_FOR_ASSET_GROUP";
export const GET_ASSET_STOCK_COMPANY = "GET_ASSET_STOCK_COMPANY";
export const GET_LOCATION = "GET_LOCATION";
export const GET_ASSET_DETAIL = "GET_ASSET_DETAIL";
export const GET_ASSET_TYPE_FOR_ASSET_FILTER =
  "GET_ASSET_TYPE_FOR_ASSET_FILTER";
export const GET_ASSET_EXPORT = "GET_ASSET_EXPORT";
export const GET_ASSET_FILTER_COMPANY = "GET_ASSET_FILTER_COMPANY";
export const GET_INSURANCE_COMPANY = "GET_INSURANCE_COMPANY";
export const GET_ASSET_FILTER_CATEGORY = "GET_ASSET_FILTER_CATEGORY";
export const GET_ASSET_FILTER_ALLOCATED = "GET_ASSET_FILTER_ALLOCATED";
export const GET_ASSET_FILTER_DEPARTMENT = "GET_ASSET_FILTER_DEPARTMENT";
export const GET_ASSET_DEPRECIATION = "GET_ASSET_DEPRECIATION";
export const GET_ASSET_HISTORY = "GET_ASSET_HISTORY";
export const GET_ASSET_ALLOCATION = "GET_ASSET_ALLOCATION";
export const GET_ASSET_STATUS = "GET_ASSET_STATUS";
export const GET_ASSET_MAINTENANCE_SETTING = "GET_ASSET_MAINTENANCE_SETTING";
export const GET_ASSET_VEHICLE_SERVICE_DETAIL =
  "GET_ASSET_VEHICLE_SERVICE_DETAIL";
export const GET_ASSET_FUEL_DETAIL = "GET_ASSET_FUEL_DETAIL";
export const GET_ASSET_INSURANCE_ACTION = "GET_ASSET_INSURANCE_ACTION";
export const GENERATE_ASSET_ADMIN_EXPENSE = "GENERATE_ASSET_ADMIN_EXPENSE";
export const GET_ASSET_DOCUMENT = "GET_ASSET_DOCUMENT";

// Asset Insurance //
export const GET_ASSET_INSURANCE = "GET_ASSET_INSURANCE";
export const GET_ASSET_INSURANCE_DETAIL = "GET_ASSET_INSURANCE_DETAIL";

// Asset Mainteance //
export const GET_ASSET_MAINTENANCE = "GET_ASSET_MAINTENANCE";
export const GET_ASSET_MAINTENANCE_DETAIL = "GET_ASSET_MAINTENANCE_DETAIL";
export const GET_ASSET_MAINTENANCE_STATUS = "GET_ASSET_MAINTENANCE_STATUS";
export const GET_ASSET_MAINTENANCE_ALLOCATION =
  "GET_ASSET_MAINTENANCE_ALLOCATION";

// Asset Transfer //
export const GET_ASSET_TRANSFER = "GET_ASSET_TRANSFER";
export const GET_ASSET_FOR_ASSET_TRANSFER = "GET_ASSET_FOR_ASSET_TRANSFER";
export const GET_ASSET_TRANSFER_DETAIL = "GET_ASSET_TRANSFER_DETAIL";
export const GET_ASSET_TRANSFER_EXPORT = "GET_ASSET_TRANSFER_EXPORT";
export const GET_ASSET_TRANSFER_FILTER_FROM_PROJECT =
  "GET_ASSET_TRANSFER_FILTER_FROM_PROJECT";
export const GET_ASSET_TRANSFER_FILTER_TO_PROJECT =
  "GET_ASSET_TRANSFER_FILTER_TO_PROJECT";
export const GET_ASSET_TRANSFER_FOR_DC = "GET_ASSET_TRANSFER_FOR_DC";
export const GET_PROJECT_FOR_ASSET_TRANSFER = "GET_PROJECT_FOR_ASSET_TRANSFER";
export const GET_ASSET_MAINTENANCE_EXPORT = "GET_ASSET_MAINTENANCE_EXPORT";
export const GET_ASSET_INSURANCE_EXPORT = "GET_ASSET_INSURANCE_EXPORT";
export const GET_ASSET_INSURANCE_FILTER_VENDOR =
  "GET_ASSET_INSURANCE_FILTER_VENDOR";
export const GET_ASSET_DETAIL_PRINT = "GET_ASSET_DETAIL_PRINT";
// Asset License
export const GET_LICENSE = "GET_LICENSE";

// License Asset
export const GET_ASSET_LICENSE_EXPORT = "GET_ASSET_LICENSE_EXPORT";
export const GET_ASSET_LICENSE = "GET_ASSET_LICENSE";
export const GET_ASSET_LICENSE_DETAIL = "GET_ASSET_LICENSE_DETAIL";
export const GET_ASSET_LICENSE_FILTER_VENDOR =
  "GET_ASSET_LICENSE_FILTER_VENDOR";
export const GET_ASSET_CATEGORY = "GET_ASSET_CATEGORY";
export const GET_ASSET_GROUP_MASTER = "GET_ASSET_GROUP_MASTER";
export const GET_SPECIFICATION_SET_FOR_GROUP =
  "GET_SPECIFICATION_SET_FOR_GROUP";
export const GET_VALUE_SET_FOR_SPECIFICATION =
  "GET_VALUE_SET_FOR_SPECIFICATION";
export const GET_SPECIFICATION = "GET_SPECIFICATION";
export const GET_SPECIFICATION_VALUE = "GET_SPECIFICATION_VALUE";
export const GET_MODEL = "GET_MODEL";
export const GET_MAKE = "GET_MAKE";
// Asset Insurance
export const GET_ASSET_INSURANCE_NUMBER = "GET_ASSET_INSURANCE_NUMBER";
// Asset Insurance type
export const GET_INSURANCE_TYPE = "GET_INSURANCE_TYPE";
// Asset License Type
export const GET_LICENSE_TYPE = "GET_LICENSE_TYPE";

// Asset License in Review form
export const GET_ASSET_LICENSE_NUMBER = "GET_ASSET_LICENSE_NUMBER";
export const GET_SPECIFICATION_VALUE_SET = "GET_SPECIFICATION_VALUE_SET";
export const GET_PAYMENT_STATUS = "GET_PAYMENT_STATUS";
export const GET_SPECIFICATION_VALUE_SET_FILTER_VALUE =
  "GET_SPECIFICATION_VALUE_SET_FILTER_VALUE";
export const GET_ASSET_CATEGORY_FILTER_GROUP =
  "GET_ASSET_CATEGORY_FILTER_GROUP";
